module.exports = __webpack_public_path__ + "img/arbre_2_ombre.a7feb8b7.png";